/* Progressive enhancement only: links, catalog data and disclosures work without JS. */
(() => {
  'use strict';
  const initialize = (scope) => {
    scope.querySelectorAll('[data-mm-smart-bar]').forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';
      const shell = bar.querySelector('[data-mm-sb-shell]');
      const toggle = bar.querySelector('[data-mm-sb-toggle]');
      const modes = bar.querySelector('.mm-sb-modes');
      const media = window.matchMedia('(max-width: 899px)');
      if (shell && toggle) {
        const syncShell = () => {
          const expanded = !media.matches;
          shell.dataset.open = String(expanded);
          toggle.setAttribute('aria-expanded', String(expanded));
        };
        toggle.addEventListener('click', () => {
          if (!media.matches) return;
          const expanded = shell.dataset.open !== 'true';
          shell.dataset.open = String(expanded);
          toggle.setAttribute('aria-expanded', String(expanded));
        });
        media.addEventListener?.('change', syncShell);
        syncShell();
      }
      if (!modes) return;
      const controls = [...modes.querySelectorAll('[data-mm-sb-mode]')];
      const modules = [...bar.querySelectorAll('[data-mm-sb-kind]')];
      controls.forEach((button) => {
        button.addEventListener('click', () => {
          const selected = button.dataset.mmSbMode;
          if (!['all', 'shop', 'learn'].includes(selected)) return;
          controls.forEach((control) => control.setAttribute('aria-pressed', String(control === button)));
          modules.forEach((module) => {
            const kind = module.dataset.mmSbKind;
            module.hidden = selected !== 'all' && kind !== 'all' && kind !== selected;
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
